<template>
  <div class="simulationCurve">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <el-form label-position="right" :model="searchForm" class="form" :inline="true">
        <el-form-item :label="$t('panelNumber')">
          <el-input-number size="mini" v-model="searchForm.controllerNo" @change="handleControllerNo" :min="0"
                           :max="254"
                           label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('loopNo')">
          <el-input-number size="mini" v-model="searchForm.loopNo" @change="handleChangeLoopNo" :min="0" :max="254"
                           label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('componentNumber')">
          <el-input-number size="mini" v-model="searchForm.siteInitiation" @change="handleChange" :min="0" :max="254"
                           label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button :loading="searching" style="width: 90px" type="primary" @click="handleStartAndStop">
            {{ startAndStop !== 'simulationCurve' ? $t('queryButton') : $t('stop') }}
          </el-button>
        </el-form-item>
      </el-form>
      <div id="main" ref="chart" style="width: 100%;"></div>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import * as echarts from "echarts";
import {getDeviceAnalog, stop} from "@/api/query"
import Status from "components/Status";

export default {
  name: "simulationCurve",
  mixins: [Status],
  components: {
    Box,
  },
  data() {
    return {
      searchForm: {
        controllerNo: 1,
        loopNo: 1,
        siteInitiation: 1
      },
      tabClickIndex: null,
      bottomHeight: null,
      clicked: true,
      tabClickLabel: '',
      oldControllerNotes: '',
      id: '',
      option: {
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            formatter: function () {
              return "";
            }
          }
        },
        yAxis: {
          type: 'value',
          max: 120,
          show: true
        },
        series: [{
          data: [0],
          type: 'line',
          symbol: 'none',
        }]
      },
      data: 0,
      timedata: 0,
      isFirst: false,
      myChart: null,
      style: null,
      searching: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.state.responseErrFlag) {
        vm.searching = false;
        vm.id = ''
        let newOption = vm.option
        newOption.xAxis.data = []
        newOption.series[0] = {
          data: [0],
          type: 'line',
          symbol: 'none'
        }
        if (vm.myChart) {
          vm.myChart.setOption(newOption, true)
        }
      }
    })
  },
  computed: {
    startAndStop: {
      get() {
        return this.$store.state.startAndStop
      },
      set(val) {
        this.$store.commit('changeStartAndStop', val);
      }
    },
    responseErrFlag() {
      return this.$store.state.responseErrFlag
    }
  },
  created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  mounted() {
    this.calcHeight()
    let dom = this.$refs.chart;
    let offsetTop = 0;// 顶部偏移量
    let el = dom;
    while (el.offsetParent) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
    }
    let innerHeight = window.innerHeight;
    dom.style.height = innerHeight - offsetTop - 75 + 'px';
    this.myChart = echarts.init(document.getElementById('main'));
    this.myChart.setOption(this.option, true);
  },
  methods: {
    init_data() {
      this.searching = false;
      this.id = ''
      let newOption = this.option
      newOption.xAxis.data = []
      newOption.series[0] = {
        data: [0],
        type: 'line',
        symbol: 'none'
      }
      if (this.myChart) {
        this.myChart.setOption(newOption, true)
      }
    },
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    handleChange(value) {
      this.searchForm.siteInitiation = value
    },
    handleControllerNo(value) {
      this.searchForm.controllerNo = value
    },
    handleChangeLoopNo(value) {
      this.searchForm.loopNo = value
    },
    handleStartAndStop() {
      const {sysSetting} = this.$store.state
      const searchParams = {
        controllerPsn: sysSetting.controllerPsn,//控制器PSN
        controllerNo: this.searchForm.controllerNo,//控制器号
        loopNo: this.searchForm.loopNo,//回路号
        codeNo: this.searchForm.siteInitiation,//部位号
        dataType: 1//默认值1:11SF，2:数据2，3：数据3
      }
      const params = {
        controllerPsn: sysSetting.controllerPsn,//控制器PSN
        id: this.id
      }
      if (this.startAndStop !== 'simulationCurve') {
        if (this.startAndStop !== '') {
          this.$message.warning("命令阻塞中!")
          return
        }
        this.show()
        this.searching = true;
        getDeviceAnalog(searchParams).then((res) => {
          if (res.data) {
            this.id = res.data.id
            this.isFirst = true
            // this.loading = false;
            //   if (currentAnalogLine.request.id === res.data.id){
            //   let newOption = this.option
            //   newOption.xAxis.data.push(this.data)
            //   newOption.series[0] = {
            //     data:[],
            //     type: 'line',
            //     }
            //   newOption.series[0].data.push(currentAnalogLine.dataUint.data[0].value)
            //   this.option = newOption
            //   this.isShow = true
            //   let myChart = echarts.init(document.getElementById('main'));
            //   myChart.setOption(this.option, true);
            //   this.timedata = Date.parse(new Date()) / 1000;
            // }
            //this.startAndStop = false
            this.$store.commit('changeStartAndStop', "simulationCurve");
            sessionStorage.startAndStop = "simulationCurve"
          }
        }).catch(() => {
          this.searching = false;
          // this.$store.commit('changeStartAndStop', "");
          // sessionStorage.startAndStop = ""
          // this.$message.error(err.message)
        })
      } else {
        this.show()
        stop(params).then((res) => {
          this.searching = false;
          if (res.data) {
            console.log('停止响应')
            this.id = ''
            this.$store.commit('changeStartAndStop', "");
            sessionStorage.startAndStop = ""
            let newOption = this.option
            this.option = newOption
            newOption.xAxis.data = []
            newOption.series[0] = {
              data: [0],
              type: 'line',
              symbol: 'none'
            }
            this.myChart.setOption(this.option, true);
          }
        }).catch(() => {
          this.searching = false;
          // this.$message.error(err.message)
          // this.$store.commit('changeStartAndStop', "simulationCurve");
          // sessionStorage.startAndStop = "simulationCurve"
        })
      }
    }
  },
  watch: {
    '$store.state.currentAnalogLine'(newVal) {
      if (newVal.request.id === this.id) {
        this.failed();
        let newOption = this.option
        this.searching = false;
        if (this.isFirst) {
          newOption.series[0] = {
            data: [],
            type: 'line',
          }
        }
        this.isFirst = false
        const timestamp = Date.parse(new Date()) / 1000;
        this.data = timestamp - this.timedata + this.data
        this.timedata = timestamp
        newOption.series[0].itemStyle = {normal: {label: {show: true}}}
        newOption.xAxis.data.push(this.data)
        newOption.series[0].data.push(newVal.dataUint.data[0].value)
        this.option = newOption
        this.isShow = true
        this.myChart.setOption(this.option, true);
      }
    },
    responseErrFlag(newVal) {
      if (newVal) {
        this.failed();
        // this.loading = false;
        // let status = this.$store.state.startAndStop
        // this.$store.commit('changeStartAndStop', status);
        // sessionStorage.startAndStop = status
        this.init_data()
      }
    }
  }
}
</script>

<style scoped>

</style>
